/**
 * @module infra-sk/modules/theme-chooser-sk
 * @description <h2><code>theme-chooser-sk</code></h2>
 *
 * <p>
 * The <theme-chooser-sk> custom element. Imports a default and darkmode color
 * palette and provides a toggle to swap between them.  To use the themes,
 * elements in the page should set colors via the variable provided in
 * infra-sk/modules/theme-chooser-sk/theme-chooser-sk.scss Such as --primary,
 * --on-primary, --background, --on-background, etc.  Some additional classes
 * are provided for convenience (primary-container-theme-sk,
 * secondary-container-theme-sk, surface, etc)
 * </p>
 *
 * <p>
 * To change the color themes override the css variables in a ':root' selector.
 * </p>
 *
 * @evt theme-chooser-toggle Sent when the theme has changed. The detail
 *   contains the darkmode value:
 *
 *   <pre>
 *     detail {
 *       darkmode: true,
 *     }
 *   </pre>
 *
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    DARKMODE_CLASS: function() {
        return DARKMODE_CLASS;
    },
    DARKMODE_LOCALSTORAGE_KEY: function() {
        return DARKMODE_LOCALSTORAGE_KEY;
    },
    ThemeChooserSk: function() {
        return ThemeChooserSk;
    },
    isDarkMode: function() {
        return isDarkMode;
    }
});
const _html = require("lit/html.js");
const _define = require("../../../elements-sk/modules/define");
const _ElementSk = require("../ElementSk");
require("../../../elements-sk/modules/icons/invert-colors-icon-sk");
const DARKMODE_CLASS = 'darkmode';
const DARKMODE_LOCALSTORAGE_KEY = 'theme-chooser-sk-darkmode';
let ThemeChooserSk = class ThemeChooserSk extends _ElementSk.ElementSk {
    connectedCallback() {
        super.connectedCallback();
        this._render();
        this.addEventListener('click', this._toggleTheme);
        // Set the class correctly based on window.localStorage.
        this.darkmode = this.darkmode; // eslint-disable-line no-self-assign
    }
    _toggleTheme() {
        this.darkmode = !this.darkmode;
    }
    get darkmode() {
        if (window.localStorage.getItem(DARKMODE_LOCALSTORAGE_KEY) === null) {
            return true; // Defaults to darkmode.
        }
        return window.localStorage.getItem(DARKMODE_LOCALSTORAGE_KEY) === 'true';
    }
    set darkmode(val) {
        // Force to be a bool.
        val = !!val;
        window.localStorage.setItem(DARKMODE_LOCALSTORAGE_KEY, val.toString());
        document.body.classList.toggle(DARKMODE_CLASS, this.darkmode);
        this.dispatchEvent(new CustomEvent('theme-chooser-toggle', {
            detail: {
                darkmode: val
            },
            bubbles: true
        }));
    }
    constructor(){
        super(ThemeChooserSk.template);
    }
};
(()=>{
    ThemeChooserSk.template = ()=>(0, _html.html)`<invert-colors-icon-sk></invert-colors-icon-sk>`;
})();
const isDarkMode = ()=>window.localStorage.getItem(DARKMODE_LOCALSTORAGE_KEY) === 'true';
(0, _define.define)('theme-chooser-sk', ThemeChooserSk);
